import { Pipe, PipeTransform } from '@angular/core';
import { GroupFilterType } from '../models/group-filter-type.model';

@Pipe({
  name: 'groupFilterType'
})
export class GroupFilterTypePipe implements PipeTransform {
  transform(value: GroupFilterType): unknown {
    switch (value) {
      case GroupFilterType.withGroups:
        return 'С группами';
      case GroupFilterType.withoutGroups:
        return 'Без групп';
      default:
        break;
    }
    return value;
  }
}
